import React from 'react';
import { ArticleCarousel, ArticleCompactInlineCard } from '@browsing/components';
import InView from 'react-intersection-observer';
import { trackSelectItem, trackViewItemList } from '@browsing/tracking';
import { isModifierKeyPressed, NavigationSourceType } from '@browsing/utils';
import { Translate, TranslateScope } from '@pegasus/translation';
import { useNavigateToPDP } from '@browsing/hooks';
import { useRecommendations } from './hooks/use-recommendations';
export var HighlightsCarousel = function (props) {
    var gender = props.gender, textTitle = props.textTitle, navigateToPDPInCurrentTab = props.navigateToPDPInCurrentTab;
    var _a = useNavigateToPDP({ navigateToPDPInCurrentTab: navigateToPDPInCurrentTab }), navigateToPDP = _a.navigateToPDP, getPDPURLPath = _a.getPDPURLPath;
    var highlightArticles = useRecommendations(gender)[0];
    var onInView = function (inView) {
        if (inView && highlightArticles.length > 0) {
            trackViewItemList({
                items: highlightArticles,
                element: 'popular_near_you_carousel',
                context: 'popular_near_you_carousel',
                itemListName: 'popular_near_you_carousel',
            });
        }
    };
    var onArticleClick = function (article, index) { return function (e) {
        trackSelectItem({
            element: 'popular_near_you_carousel',
            itemListName: 'popular_near_you_carousel',
            context: 'popular_near_you_carousel',
            item: article,
        }, {
            customMapper: function () { return ({ index: index }); },
        });
        // Prevent clicks on LUX <ArticleCard/>, whose children are wrapped in a link, from navigating to the PDP.
        e.preventDefault();
        navigateToPDP({
            queryParams: {
                campaignId: article.campaignIdentifier,
                configSku: article.sku,
                navigationSource: NavigationSourceType.Highligts,
            },
            shouldOpenInNewTab: isModifierKeyPressed(e),
        });
    }; };
    // Pass `pdpURLPath` to <ArticleCard/>'s link for accessibility/robustness, even though we prevent its
    // default behavior. e.g. the user might right-click the link, which is not handled here.
    var getArticleURLPath = function (article) {
        return getPDPURLPath({
            queryParams: {
                campaignId: article.campaignIdentifier,
                configSku: article.sku,
                navigationSource: NavigationSourceType.Highligts,
            },
        });
    };
    if (highlightArticles.length <= 0) {
        return null;
    }
    return (React.createElement(InView, { as: "div", onChange: onInView, triggerOnce: true, "data-testid": "mylounge-recommendation-wrapper" },
        React.createElement(TranslateScope, { path: "article" },
            React.createElement(ArticleCarousel, { id: "highlights-carousel-headline", title: React.createElement(TranslateScope, null,
                    React.createElement(Translate, { message: "highlights.carouselTitle" })), textTitle: textTitle }, highlightArticles.map(function (article, index) { return (React.createElement(ArticleCompactInlineCard, { key: article.sku, brand: article.brand, onClick: onArticleClick(article, index), media: article.media, nameCategoryTag: article.nameCategoryTag, nameColor: "", nameShop: "", price: article.price, specialPrice: article.specialPrice, pdpURLPath: getArticleURLPath(article) })); })))));
};
